<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Autres services" />
            <AutreService />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import AutreService from '../Services/AutreService'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'AutreServicePage',
    components: {
        NavBar,
        PageTitle,
        AutreService,
        FooterComp,
    }
}
</script>